import React from 'react'
import { useTheme } from '../../../../Utils/useTheme'
import { Column } from '../types'
import { PopoverPortal, useAnchorPosition } from './PopoverPortal'
import { Switch } from '../../Switch'

export const ColumnSettingsPanel = ({
  anchorRect,
  columns,
  hidden,
  onToggleHidden,
  onClose
}: {
  anchorRect: DOMRect | null
  columns: Column<any>[]
  hidden: Record<string, boolean>
  onToggleHidden: (key: string) => void
  onClose: () => void
}) => {
  const { border, text, hover } = useTheme()
  const pos = useAnchorPosition(anchorRect, 320, 420, 'right')

  return (
    <PopoverPortal>
      <div
        style={{
          position: 'fixed',
          left: pos.left,
          top: pos.top,
          width: 320,
          maxHeight: 420,
          background: 'white',
          border: `1px solid ${border}`,
          borderRadius: 14,
          padding: 10,
          boxShadow: 'rgba(0,0,0,0.22) 0px 18px 46px',
          zIndex: 999999
        }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, paddingBottom: 8 }}>
          <div style={{ color: text, fontWeight: 600, fontSize: 13, flex: 1 }}>Columns</div>
          <div
            style={{
              width: 28,
              height: 28,
              borderRadius: 10,
              border: `1px solid ${border}`,
              background: 'rgba(17,24,39,0.06)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: text
            }}
            onMouseEnter={e => (e.currentTarget.style.background = hover)}
            onMouseLeave={e => (e.currentTarget.style.background = 'rgba(17,24,39,0.06)')}
            onClick={onClose}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </div>
        </div>

        <div style={{ height: 1, background: border, opacity: 0.7 }} />

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            marginTop: 10,
            maxHeight: 360,
            overflow: 'auto'
          }}
        >
          {columns.map(c => {
            const visible = !hidden[c.key]
            return (
              <div
                key={c.key}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  padding: '10px 10px',
                  borderRadius: 12,
                  cursor: 'pointer',
                  color: text
                }}
                onMouseEnter={e => (e.currentTarget.style.background = hover)}
                onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}
                onClick={() => onToggleHidden(c.key)}
              >
                <div style={{ fontSize: 12, fontWeight: 600 }}>{c.title}</div>

                <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 10 }}>
                  <div style={{ opacity: 0.6, fontSize: 12 }}>{visible ? 'Visible' : 'Hidden'}</div>
                  <div onClick={e => e.stopPropagation()}>
                    <Switch value={visible} onChange={() => onToggleHidden(c.key)} size={22} />
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </PopoverPortal>
  )
}
